/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BusinessInfoDto } from '../../models/business-info-dto';

export interface BusinessInfoControllerFind$Params {
}

export function businessInfoControllerFind(http: HttpClient, rootUrl: string, params?: BusinessInfoControllerFind$Params, context?: HttpContext): Observable<StrictHttpResponse<BusinessInfoDto>> {
  const rb = new RequestBuilder(rootUrl, businessInfoControllerFind.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BusinessInfoDto>;
    })
  );
}

businessInfoControllerFind.PATH = '/api/businessInfo';
